<template lang="pug">
.ref-thank-you
	p.ref-thank-you__header Thank you for your referral!
	.ref-thank-you__divider
	button.ref-thank-you__again.btn(type="button" @click="goBack()") Refer another friend.
</template>

<script>
import socialLinks from "./../components/social-links.vue";

export default {
  name: "ThankYou",
  props: ["data", "config"],
  components: {
    socialLinks,
  },
  methods: {
    goBack() {
      Object.keys(this.data).forEach((key) => {
        this.data[key] = "";
      });
      this.$emit("resetForm");
    },
  },
};
</script>

<style lang="scss">
.ref-thank-you {
  &__header {
    font-size: 1.1rem;
    color: #2b2e2f;
    margin-bottom: 0.5rem;
    font-weight: bold;
  }
  &__copy {
    font-size: 0.9rem;
    margin-bottom: 0;
  }
  &__divider {
    border-top: 1px solid #979797;
    margin-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
}
</style>
